import { render, staticRenderFns } from "./PatentInventorList.vue?vue&type=template&id=5faa8af6&"
import script from "./PatentInventorList.vue?vue&type=script&lang=js&"
export * from "./PatentInventorList.vue?vue&type=script&lang=js&"
import style0 from "./PatentInventorList.vue?vue&type=style&index=0&id=5faa8af6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports